import { render } from "./MaterialAsinSwap.vue?vue&type=template&id=114d5ca2"
import script from "./MaterialAsinSwap.vue?vue&type=script&lang=js"
export * from "./MaterialAsinSwap.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__